<template lang="html">
  <section class="vh intro vehiculo-electrico">
    <img class="w-100" src="/static/img/vehiculo-electrico/bg-intro.webp"
      :alt="$t('productos.alt_images.taller_electrico')" :title="$t('productos.alt_images.taller_electrico')" width="1280" height="598" />
    <a href="#" v-scroll-to="'.carasteristicas-vehiculo'" class="scrolldown"></a>
    <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <!--         <img class="logo-ve" src="/static/img/vehiculo-electrico/logo_vehiculo_electrico.png" alt="Logo Ajusa VE" width="1920" height="1920" /> -->
        <h1 class="title title-52">
          {{ $t("vehiculo_electrico.intro_titulo") }}
        </h1>
        <p v-html="$t('vehiculo_electrico.descripcion_intro')"></p>
        <div class="container-btns">
          <a class="btn-amarillo" target="_blank" href="/static/pdf/ajusa-electric-engine-catalogue.pdf">{{
            $t("enlaces.textos.catalogo_motor_electrico") }}</a>
          <a target="_blank" href="/static/pdf/ajusa-a_ccompressor-catalogue.pdf" class="btn-amarillo">{{
            $t("enlaces.textos.catalogo_comprensorAC") }}</a>
        </div>
        <p v-html="$t('vehiculo_electrico.descripcion_intro2')"></p>
        <video-el :data="videointro" @show="sendToShow" :idkey="'videointro'"></video-el>
        <div class="flex column nowrap justify-center align-center online-store">
          <img class="logo" src="/static/img/vehiculo-electrico/electric-vehicle-line-logo.svg"
            :alt="$t('alt_images.vehiculo_electrico')" width="377" height="107" />
          <a :href="$t(`enlaces.online_store`)" target="_blank" class="btn btn-blue">
            {{ $t("enlaces.textos.online_store") }}
          </a>
        </div>
      </div>
    </div>
    <div class="col-50-right flex column nowrap justify-center align-center animated fadeInRight">
      <div class="flex column nowrap justify-center align-center">
        <img class="logo" src="/static/img/vehiculo-electrico/electric-vehicle-line-logo.svg"
          :alt="$t('alt_images.vehiculo_electrico')" width="377" height="107" />
        <a :href="$t(`enlaces.online_store`)" target="_blank" class="btn btn-blue">
          {{ $t("enlaces.textos.online_store") }}
        </a>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import Video_el from '@/components/parts/video-el-vehiculo-electrico';
import VideoVisualizer from '@/components/parts/video-visualizer.vue';

export default {
  name: 'vehiculo-electrico',
  props: [],
  components: {
    'video-el': Video_el,
    'video-visualizer': VideoVisualizer,
  },
  mounted() {

  },
  data() {
    return {
      'videointro': {
        'id': 'vehiculo-electrico',
        'videoId': 'svouPU4u8jY'
      },
      video_to_show: '',
      show_video: false,
    }
  },
  methods: {
    sendToShow: function (value) {
      this.video_to_show = value;
      this.show_video = true;
    },
    closeVideo: function () {
      this.show_video = false;
      this.video_to_show = '';
    }
  },

}
</script>

<style scoped>
.vehiculo-electrico .vh.intro img.logo-ve {
  max-width: 120px;
  height: auto;
  position: absolute;
  right: -120px;
  top: -20px;
}

.vehiculo-electrico .vh.intro img.logo {
  top: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: relative;
}

.vehiculo-electrico .container-text {
  position: relative;
}

@media screen and (max-width: 1024px) {
  .vehiculo-electrico .vh.intro img.logo-ve {
    right: 0;
    top: 0;
  }
}

@media (max-width: 600px) and (max-height: 950px) {
  .vehiculo-electrico .vh.intro img.logo-ve {
    right: 0;
    top: -45px;
  }

  .vehiculo-electrico .title.title-52 {
    font-size: 48px !important;
  }
}

@media (max-width: 600px) and (max-height: 700px) {
  .vehiculo-electrico .vh.intro {
    height: 140vh !important;
  }

  .vehiculo-electrico .vh.intro img.logo-ve {
    right: 0;
    top: -86px;
    max-width: 80px;
  }
}

@media screen and (max-height: 790px) {
  .vehiculo-electrico .vh.intro {
    height: 154vh !important;
  }

  .vehiculo-electrico .vh.intro img.logo-ve {
    max-width: 108px;
    height: auto;
    position: absolute;
    right: -75px;
    top: 0px;
  }
}

@media (max-width: 1465px) and (max-height: 790px) {
  .vehiculo-electrico .vh.intro img.logo-ve {
    max-width: 86px;
    right: -43px;
    top: 0px;
  }
}

@media (max-width: 1320px) and (max-height: 790px) {
  .vehiculo-electrico .title-52 {
    font-size: 59px !important;
    margin-top: 10px !important;
  }

  .vehiculo-electrico .vh.intro img.logo-ve {
    max-width: 130px;
    right: 0px;
  }
}

@media (max-width: 1155px) and (max-height: 790px) {
  .vehiculo-electrico .vh.intro img.logo-ve {
    right: 0;
    top: -19px;
  }
}

@media (max-width: 600px) and (max-height: 790px) {
  .vehiculo-electrico .vh.intro img.logo-ve {
    right: 0;
  }
}

@media screen and (max-height: 700px) {
  .vehiculo-electrico .vh.intro img.logo-ve {
    right: 0;
    top: -55px;
    max-width: 80px;
  }
}

@media (max-width: 400px) and (max-height: 700px) {
  .vehiculo-electrico .vh.intro img.logo-ve {
    top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/vehiculo-electrico.vue